import { render, staticRenderFns } from "./record.vue?vue&type=template&id=c4c6c02c&"
import script from "./record.ts?vue&type=script&lang=ts&"
export * from "./record.ts?vue&type=script&lang=ts&"
import style0 from "../offlineResourceMgr.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports